import type { InfoClient } from "@nktkas/hyperliquid";
import { useQuery } from "@tanstack/react-query";
import { getInfoClient } from "#/features/trade/lib/hyperliquid";
import { queryKeys } from "./query-keys";
import { useWallet } from "./use-wallet";

type PortfolioResponse = Awaited<ReturnType<InfoClient["portfolio"]>>;
export type PortfolioPeriod = PortfolioResponse[number][0];
export type PortfolioBucket = PortfolioResponse[number][1];

export type PortfolioByPeriod = Record<PortfolioPeriod, PortfolioBucket>;

export function useHyperPortfolio() {
	const { address } = useWallet();
	const infoClient = getInfoClient();

	const query = useQuery({
		queryKey: queryKeys.hyper.portfolio(address),
		queryFn: () =>
			infoClient.portfolio({
				user: address as `0x${string}`,
			}),
		staleTime: 20_000,
		refetchInterval: 30_000,
		enabled: address !== null,
	});

	const byPeriod: PortfolioByPeriod | undefined = query.data
		? (Object.fromEntries(query.data) as PortfolioByPeriod)
		: undefined;

	return { ...query, byPeriod };
}
